module.exports = __webpack_public_path__ + "media/promo/advent/images/play-f2bfa27d1e74156979d586c6e323f1f6.svg";